<div
  *transloco="let t; read: 'select-collection-configuration'"
  class="xi-modal__container collection-analysis-type__container"
>
  <h2 class="xi-modal__title">{{ t('title') }}</h2>

  <div class="collection-analysis-type__content">
    <form autocomplete="off">
      <app-analysis-config-selector
        class="config-selector"
        [collection]="collection.data"
        [selectedConfigId]="configurationId"
        [suggestLastUsed]="!configurationId"
        [disabled]="false"
        (selectedConfig)="selectConfig($event)"
        (selectedRouteLang)="selectLanguage($event)"
      ></app-analysis-config-selector>
    </form>
  </div>

  <div class="xi-modal__actions collection-analysis-type__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="cancel()"></xi-default-button>

    <div class="xi-loader-button-container">
      <xi-default-button
        [text]="t('confirm')"
        [disabled]="!configurationId"
        (onClick)="save()"
      ></xi-default-button>
    </div>
  </div>
</div>
